


















import { Component, Vue, Prop } from 'vue-property-decorator';
import Cupra from '@/components/brands/Cupra.vue';
import Audi from '@/components/brands/Audi.vue';
import Volkswagen from '@/components/brands/Volkswagen.vue';
import MarketingCode from '@/components/MarketingCode.vue';
import Dealer from '@/components/Dealer.vue';
import { GiveawayResponse } from '@/constants/interfaces';
import { brandContext } from '@/constants/locales';

@Component({
  components: {
    Cupra,
    Audi,
    Volkswagen,
    MarketingCode,
    Dealer
  }
})
export default class Header extends Vue {
  @Prop() giveawayResponse!: GiveawayResponse;
  private showNavbar = true;
  private lastScrollPosition = 0;
  private didScroll = false;

  get brandContext() {
    return brandContext;
  }

  mounted() {
    window.addEventListener('scroll', this.onScroll);
    setInterval(this.scrollCheck, 250);
  }
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    this.didScroll = true;
  }

  scrollCheck() {
    if (this.didScroll) {
      this.throttledNavBarCheck();
      this.didScroll = false;
    }
  }

  throttledNavBarCheck() {
    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    if (currentScrollPosition < 0) {
      return;
    }
    if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 45) {
      return;
    }
    this.showNavbar = currentScrollPosition < this.lastScrollPosition;
    this.lastScrollPosition = currentScrollPosition;
  }
}
